export default (dialog) => {
  return {
    dialog: null,
    init() {
      this.dialog =
        this.$el.tagName.toUpperCase() === "DIALOG"
          ? this.$el
          : this.$el.querySelector("dialog");

      if (this.dialog) {
        this.dialog.addEventListener("click", (event) => {
          if (event.target.tagName.toUpperCase() === "DIALOG") {
            this.dialog.close();
          }
        });
      }
      document.addEventListener("turbo:frame-load", (event) => {
        if (event.target.id == "turbo_modal") {
          this.open();
        }
      });
      document.addEventListener("turbo:submit-end", (event) => {
        if (event.detail.success) this.closeOnFormSubmit();
      });
    },
    open() {
      this.dialog.showModal();
      document.activeElement?.blur();
    },
    close() {
      this.dialog.close();
    },
    closeOnFormSubmit() {
      if (!this.hasNextModel()) {
        this.dialog.close();
      }
    },
    hasNextModel() {
      return this.dialog.querySelector(".next-modal") !== null;
    },
  };
};
